import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getOthersDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  // welcomePageForCalendar: [
  //   {
  //     fieldName: "Calendar Header (EN)",
  //     fieldValue: "title",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "title",
  //     formType: "input",
  //     label: "Calendar Header (EN)",
  //     placeholder: "Enter Title",
  //     validation: { required: "Calendar Header (EN) is required" },
  //   },
  //   {
  //     fieldName: "Calendar Header (MS)",
  //     fieldValue: "field_malay_calendar_header_text",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "field_malay_calendar_header_text",
  //     formType: "input",
  //     label: "Calendar Header (MS)",
  //     placeholder: "Enter Calendar Header (MS)",
  //     // validation: { required: "Calendar Header (MS) is required" },
  //   },
  //   {
  //     fieldName: "Calendar Header (ZH)",
  //     fieldValue: "field_mandarin_calendar_header_t",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "field_mandarin_calendar_header_t",
  //     formType: "input",
  //     label: "Calendar Header (ZH)",
  //     placeholder: "Enter Calendar Header (ZH)",
  //     // validation: { required: "Calendar Header (ZH) is required" },
  //   },
  //   {
  //     fieldName: "Welcome Calendar (EN)",
  //     fieldValue: "field_welcome_calendar_text",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "field_welcome_calendar_text",
  //     formType: "input",
  //     label: "Welcome Calendar (EN)",
  //     placeholder: "Enter Welcome Calendar Text (EN)",
  //     validation: { required: "Welcome Calendar Text (EN) is required" },
  //   },
  //   {
  //     fieldName: "Welcome Calendar (MS)",
  //     fieldValue: "field_malay_welcome_calendar_tex",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "field_malay_welcome_calendar_tex",
  //     formType: "input",
  //     label: "Welcome Calendar (MS)",
  //     placeholder: "Enter Welcome Calendar (MS) Text",
  //     // validation: { required: "Welcome Calendar (MS) Text is required" },
  //   },
  //   {
  //     fieldName: "Welcome Calendar (ZH)",
  //     fieldValue: "field_mandarin_welcome_calendar",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "field_mandarin_welcome_calendar",
  //     formType: "input",
  //     label: "Welcome Calendar (ZH)",
  //     placeholder: "Enter Welcome Calendar (ZH) Text",
  //     // validation: { required: "Welcome Calendar (ZH) Text is required" },
  //   },
  //   // {
  //   //   fieldName: "Welcome Calendar Description (EN)",
  //   //   fieldValue: "field_welcome_calendar_descripti",
  //   //   className: "col-span-6",
  //   //   type: "text",
  //   //   name: "field_welcome_calendar_descripti",
  //   //   formType: "richText",
  //   //   label: "Welcome Calendar Description (EN)",
  //   //   placeholder: "Enter Welcome Calendar Description (EN)",
  //   //   validation: { required: "Welcome Calendar Description (EN) is required" },
  //   // },
  //   // {
  //   //   fieldName: "Welcome Calendar Description (MS)",
  //   //   fieldValue: "field_malay_welcome_calendar_des",
  //   //   className: "col-span-6",
  //   //   type: "text",
  //   //   name: "field_malay_welcome_calendar_des",
  //   //   formType: "richText",
  //   //   label: "Welcome Calendar Description (MS)",
  //   //   placeholder: "Enter Welcome Calendar Description (MS)",
  //   //   // validation: { required: "Welcome Calendar Description (MS) is required" },
  //   // },
  //   // {
  //   //   fieldName: "Welcome Calendar Description (ZH)",
  //   //   fieldValue: "field_mandari_welco_calen_descri",
  //   //   className: "col-span-6",
  //   //   type: "text",
  //   //   name: "field_mandari_welco_calen_descri",
  //   //   formType: "richText",
  //   //   label: "Welcome Calendar Description (ZH)",
  //   //   placeholder: "Enter Welcome Calendar Description (ZH)",
  //   //   // validation: { required: "Mandari Welcome Calendar Description is required" },
  //   // },
  //   {
  //     fieldName: "Calendar Welcome Continue (EN)",
  //     fieldValue: "field_calendar_welcom_continue",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "field_calendar_welcom_continue",
  //     formType: "input",
  //     label: "Calendar Welcome Continue (EN)",
  //     placeholder: "Enter Calendar Welcome Continue Text (EN)",
  //     validation: { required: "Calendar Welcome Continue Text (EN) is required" },
  //   },
  //   {
  //     fieldName: "Continue Text (MS)",
  //     fieldValue: "field_malay_continue_text",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "field_malay_continue_text",
  //     formType: "input",
  //     label: "Continue Text (MS)",
  //     placeholder: "Enter Continue Text (MS)",
  //     // validation: { required: "Continue Text (MS) is required" },
  //   },
  //   {
  //     fieldName: "Continue Text (ZH)",
  //     fieldValue: "field_mandarin_continue_text",
  //     className: "col-span-6",
  //     type: "text",
  //     name: "field_mandarin_continue_text",
  //     formType: "input",
  //     label: "Continue Text (ZH)",
  //     placeholder: "Enter Continue Text (ZH)",
  //     // validation: { required: "Continue Text (ZH) is required" },
  //   },
  //   {
  //     fieldName: "MAGP Image",
  //     fieldValue: "field_magp_image",
  //     className: "col-span-6",
  //     type: "image",
  //     name: "field_magp_image",
  //     formType: "file",
  //     usedFileType: 'image/*',
  //     label: "MAGP Image",
  //     placeholder: "Upload MAGP Image",
  //     validation: { required: "MAGP Image is required" },
  //   },
  // ],
  welcomePageForCalendar: [
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_malay_calendar_header_text",
      className: "col-span-6",
      type: "text",
      name: "field_malay_calendar_header_text",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_mandarin_calendar_header_t",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_calendar_header_t",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Welcome Page Image",
      fieldValue: "field_magp_image",
      className: "col-span-6",
      type: "image",
      name: "field_magp_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Welcome Page Image",
      placeholder: "Upload Image",
      validation: { required: "Welcome Page Image is required" },
    },
    {
      fieldName: "Welcome Text (EN)",
      fieldValue: "field_welcome_calendar_text",
      className: "col-span-6",
      type: "text",
      name: "field_welcome_calendar_text",
      formType: "input",
      label: "Welcome Text (EN)",
      placeholder: "Enter Welcome Text (EN)",
      validation: { required: "Welcome Text (EN) is required" },
    },
    {
      fieldName: "Welcome Text (MS)",
      fieldValue: "field_malay_welcome_calendar_tex",
      className: "col-span-6",
      type: "text",
      name: "field_malay_welcome_calendar_tex",
      formType: "input",
      label: "Welcome Text (MS)",
      placeholder: "Enter Welcome Text (MS)",
      // validation: { required: "Welcome Text (MS) is required" },
    },
    {
      fieldName: "Welcome Text (ZH)",
      fieldValue: "field_mandarin_welcome_calendar",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_welcome_calendar",
      formType: "input",
      label: "Welcome Text (ZH)",
      placeholder: "Enter Welcome Text (ZH)",
      // validation: { required: "Welcome Text (ZH) is required" },
    },
    // {
    //   fieldName: "Welcome Description (EN)",
    //   fieldValue: "field_welcome_calendar_descripti",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_welcome_calendar_descripti",
    //   formType: "richText",
    //   label: "Welcome Description (EN)",
    //   placeholder: "Enter Welcome Description (EN)",
    //   validation: { required: "Welcome Description (EN) is required" },
    // },
    // {
    //   fieldName: "Welcome Description (MS)",
    //   fieldValue: "field_malay_welcome_calendar_des",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_malay_welcome_calendar_des",
    //   formType: "richText",
    //   label: "Welcome Description (MS)",
    //   placeholder: "Enter Welcome Description (MS)",
    //   // validation: { required: "Procurement Text (MS) is required" },
    // },
    // {
    //   fieldName: "Welcome Description (ZH)",
    //   fieldValue: "field_mandari_welco_calen_descri",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_mandari_welco_calen_descri",
    //   formType: "richText",
    //   label: "Welcome Description (ZH)",
    //   placeholder: "Enter Welcome Description (ZH)",
    //   // validation: { required: "Procurement Text (ZH) is required" },
    // },
    {
      fieldName: "Continue Text (EN)",
      fieldValue: "field_calendar_welcom_continue",
      className: "col-span-6",
      type: "text",
      name: "field_calendar_welcom_continue",
      formType: "input",
      label: "Continue Text (EN)",
      placeholder: "Enter Continue Text (EN)",
      validation: { required: "Continue Text (EN) is required" },
    },
    {
      fieldName: "Continue Text (MS)",
      fieldValue: "field_malay_continue_text",
      className: "col-span-6",
      type: "text",
      name: "field_malay_continue_text",
      formType: "input",
      label: "Continue Text (MS)",
      placeholder: "Enter Continue Text (MS)",
      // validation: { required: "Guidelines Text (MS) is required" },
    },
    {
      fieldName: "Continue Text (ZH)",
      fieldValue: "field_mandarin_continue_text",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_continue_text",
      formType: "input",
      label: "Continue Text (ZH)",
      placeholder: "Enter Continue Text (ZH)",
      // validation: { required: "Guidelines Text (ZH) is required" },
    },
  ],
  calendarLegends: [
    {
      fieldName: "Start Day (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Start Day (EN)",
      placeholder: "Enter Start Day",
      validation: { required: "Start Day (EN) is required" },
    },
    {
      fieldName: "Start Day (MS)",
      fieldValue: "field_start_day_ms",
      className: "col-span-6",
      type: "text",
      name: "field_start_day_ms",
      formType: "input",
      label: "Start Day (MS)",
      placeholder: "Enter Start Day (MS)",
      // validation: { required: "Start Day (MS) is required" },
    },
    {
      fieldName: "Start Day (ZH)",
      fieldValue: "field_start_day_zh",
      className: "col-span-6",
      type: "text",
      name: "field_start_day_zh",
      formType: "input",
      label: "Start Day (ZH)",
      placeholder: "Enter Start Day (ZH)",
      // validation: { required: "Start Day (ZH) is required" },
    },
    {
      fieldName: "Start Day Color Code",
      fieldValue: "field_start_day_color_code",
      className: "col-span-6",
      type: "text",
      name: "field_start_day_color_code",
      formType: "color",
      label: "Start Day Color Code",
      placeholder: "Enter Start Day Color Code",
      validation: { required: "Start Day Color Code is required" },
    },
    {
      fieldName: "Current Day (EN)",
      fieldValue: "field_current_day_en",
      className: "col-span-6",
      type: "text",
      name: "field_current_day_en",
      formType: "input",
      label: "Current Day (EN)",
      placeholder: "Enter Current Day Text (EN)",
      validation: { required: "Current Day Text (EN) is required" },
    },
    {
      fieldName: "Current Day (MS)",
      fieldValue: "field_current_day_ms",
      className: "col-span-6",
      type: "text",
      name: "field_current_day_ms",
      formType: "input",
      label: "Current Day (MS)",
      placeholder: "Enter Current Day (MS) Text",
      // validation: { required: "Current Day (MS) Text is required" },
    },
    {
      fieldName: "Current Day (ZH)",
      fieldValue: "field_current_day_zh",
      className: "col-span-6",
      type: "text",
      name: "field_current_day_zh",
      formType: "input",
      label: "Current Day (ZH)",
      placeholder: "Enter Current Day (ZH) Text",
      // validation: { required: "Current Day (ZH) Text is required" },
    },
    {
      fieldName: "Current Day Color Code",
      fieldValue: "field_current_day_color_code",
      className: "col-span-6",
      type: "text",
      name: "field_current_day_color_code",
      formType: "color",
      label: "Current Day Color Code",
      placeholder: "Enter Current Day Color Code",
      validation: { required: "Current Day Color Code is required" },
    },
    {
      fieldName: "Expiry Day (EN)",
      fieldValue: "field_exp_date_en",
      className: "col-span-6",
      type: "text",
      name: "field_exp_date_en",
      formType: "input",
      label: "Expiry Day (EN)",
      placeholder: "Enter Expiry Day Text (EN)",
      validation: { required: "Expiry Day Text (EN) is required" },
    },
    {
      fieldName: "Expiry Day Text (MS)",
      fieldValue: "field_exp_date_ms",
      className: "col-span-6",
      type: "text",
      name: "field_exp_date_ms",
      formType: "input",
      label: "Expiry Day Text (MS)",
      placeholder: "Enter Expiry Day Text (MS)",
      // validation: { required: "Expiry Day Text (MS) is required" },
    },
    {
      fieldName: "Expiry Day Text (ZH)",
      fieldValue: "field_exp_date_zh",
      className: "col-span-6",
      type: "text",
      name: "field_exp_date_zh",
      formType: "input",
      label: "Expiry Day Text (ZH)",
      placeholder: "Enter Expiry Day Text (ZH)",
      // validation: { required: "Expiry Day Text (ZH) is required" },
    },
    {
      fieldName: "Expiry Day Color Code",
      fieldValue: "field_exp_day_color_code",
      className: "col-span-6",
      type: "text",
      name: "field_exp_day_color_code",
      formType: "color",
      label: "Expiry Day Color Code",
      placeholder: "Enter Expiry Day Color Code",
      validation: { required: "Expiry Day Color Code is required" },
    },
    {
      fieldName: "Multiple Day (EN)",
      fieldValue: "field_multi_en",
      className: "col-span-6",
      type: "text",
      name: "field_multi_en",
      formType: "input",
      label: "Multiple Day (EN)",
      placeholder: "Enter Multiple Day Text (EN)",
      validation: { required: "Multiple Day Text (EN) is required" },
    },
    {
      fieldName: "Multiple Day Text (MS)",
      fieldValue: "field_multi_ms",
      className: "col-span-6",
      type: "text",
      name: "field_multi_ms",
      formType: "input",
      label: "Multiple Day Text (MS)",
      placeholder: "Enter Multiple Day Text (MS)",
      // validation: { required: "Multiple Day Text (MS) is required" },
    },
    {
      fieldName: "Multiple Day Text (ZH)",
      fieldValue: "field_multi_zh",
      className: "col-span-6",
      type: "text",
      name: "field_multi_zh",
      formType: "input",
      label: "Multiple Day Text (ZH)",
      placeholder: "Enter Multiple Day Text (ZH)",
      // validation: { required: "Multiple Day Text (ZH) is required" },
    },
    {
      fieldName: "Multiple Day Color Code",
      fieldValue: "field_multi_contract_code",
      className: "col-span-6",
      type: "text",
      name: "field_multi_contract_code",
      formType: "color",
      label: "Multiple Day Color Code",
      placeholder: "Enter Multiple Day Color Code",
      validation: { required: "Multiple Day Color Code is required" },
    },
  ],
  webBannerImages: [
    {
      fieldName: "Title (EN)",
      fieldValue: "title_en",
      className: "col-span-6",
      type: "text",
      name: "title_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "title_ms",
      className: "col-span-6",
      type: "text",
      name: "title_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "title_zh",
      className: "col-span-6",
      type: "text",
      name: "title_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Upload Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "description_en",
      className: "col-span-6",
      type: "text",
      name: "description_en",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      // validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "description_ms",
      className: "col-span-6",
      type: "text",
      name: "description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Procurement Text (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "description_zh",
      className: "col-span-6",
      type: "text",
      name: "description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Procurement Text (ZH) is required" },
    },
  ],
  mobileHomepageBannerSlider: [
    {
      fieldName: "Order Sequence",
      fieldValue: "sequence",
      className: "col-span-6",
      type: "text",
      name: "sequence",
      formType: "number",
      label: "Order Sequence",
      placeholder: "Enter Order Sequence",
      validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "name_en",
      className: "col-span-6",
      type: "text",
      name: "name_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "name_ms",
      className: "col-span-6",
      type: "text",
      name: "name_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "name_zh",
      className: "col-span-6",
      type: "text",
      name: "name_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Upload Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "description_en",
      className: "col-span-6",
      type: "text",
      name: "description_en",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      // validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "description_ms",
      className: "col-span-6",
      type: "text",
      name: "description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Procurement Text (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "description_zh",
      className: "col-span-6",
      type: "text",
      name: "description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Procurement Text (ZH) is required" },
    },
  ],
  guestLoginFooterPage: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Upload Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Copyright Text (EN)",
      fieldValue: "copyright_text_en",
      className: "col-span-6",
      type: "text",
      name: "copyright_text_en",
      formType: "input",
      label: "Copyright Text (EN)",
      placeholder: "Enter Copyright Text (EN)",
      validation: { required: "Copyright Text (EN) is required" },
    },
    {
      fieldName: "Copyright Text (MS)",
      fieldValue: "copyright_text_ms",
      className: "col-span-6",
      type: "text",
      name: "copyright_text_ms",
      formType: "input",
      label: "Copyright Text (MS)",
      placeholder: "Enter Copyright Text (MS)",
      // validation: { required: "Copyright Text (MS) is required" },
    },
    {
      fieldName: "Copyright Text (ZH)",
      fieldValue: "copyright_text_zh",
      className: "col-span-6",
      type: "text",
      name: "copyright_text_zh",
      formType: "input",
      label: "Copyright Text (ZH)",
      placeholder: "Enter Copyright Text (ZH)",
      // validation: { required: "Copyright Text (ZH) is required" },
    },
    {
      fieldName: "Button 1 (EN)",
      fieldValue: "button_list[0].button_en",
      className: "col-span-6",
      type: "text",
      name: "button_text_en_0",
      formType: "input",
      label: "Button 1 (EN)",
      placeholder: "Enter Button 1 (EN)",
      validation: { required: "Button (EN) 1 is required" },
    },
    {
      fieldName: "Button 1 (MS)",
      fieldValue: "button_list[0].button_ms",
      className: "col-span-6",
      type: "text",
      name: "button_text_ms_0",
      formType: "input",
      label: "Button 1 (MS)",
      placeholder: "Enter Button 1 (MS)",
      // validation: { required: "Button 1 (MS) is required" },
    },
    {
      fieldName: "Button 1 (ZH)",
      fieldValue: "button_list[0].button_zh",
      className: "col-span-6",
      type: "text",
      name: "button_text_zh_0",
      formType: "input",
      label: "Button 1 (ZH)",
      placeholder: "Enter Button 1 (ZH)",
      // validation: { required: "Button 1 (ZH) is required" },
    },
    {
      fieldName: "Button 1 Link",
      fieldValue: "button_list[0].button_link",
      className: "col-span-6",
      type: "text",
      name: "button_link_0",
      formType: "input",
      label: "Button 1 Link",
      placeholder: "Enter Button 1 Link",
      validation: { required: "Button 1 Link is required" },
    },
    {
      fieldName: "Button 2 (EN)",
      fieldValue: "button_list[1].button_en",
      className: "col-span-6",
      type: "text",
      name: "button_text_en_1",
      formType: "input",
      label: "Button 2 (EN)",
      placeholder: "Enter Button 2 (EN)",
      validation: { required: "Button (EN) 2 is required" },
    },
    {
      fieldName: "Button 2 (MS)",
      fieldValue: "button_list[1].button_ms",
      className: "col-span-6",
      type: "text",
      name: "button_text_ms_1",
      formType: "input",
      label: "Button 2 (MS)",
      placeholder: "Enter Button 2 (MS)",
      // validation: { required: "Button 2 (MS) is required" },
    },
    {
      fieldName: "Button 2 (ZH)",
      fieldValue: "button_list[1].button_zh",
      className: "col-span-6",
      type: "text",
      name: "button_text_zh_1",
      formType: "input",
      label: "Button 2 (ZH)",
      placeholder: "Enter Button 2 (ZH)",
      // validation: { required: "Button 12 (ZH) is required" },
    },
    {
      fieldName: "Button 2 Link",
      fieldValue: "button_list[1].button_link",
      className: "col-span-6",
      type: "text",
      name: "button_link_1",
      formType: "input",
      label: "Button 2 Link",
      placeholder: "Enter Button 2 Link",
      validation: { required: "Button 2 Link is required" },
    },

    {
      fieldName: "Button 3 (EN)",
      fieldValue: "button_list[2].button_en",
      className: "col-span-6",
      type: "text",
      name: "button_text_en_2",
      formType: "input",
      label: "Button 3 (EN)",
      placeholder: "Enter Button 3 (EN)",
      validation: { required: "Button (EN) 3 is required" },
    },
    {
      fieldName: "Button 3 (MS)",
      fieldValue: "button_list[2].button_ms",
      className: "col-span-6",
      type: "text",
      name: "button_text_ms_2",
      formType: "input",
      label: "Button 3 (MS)",
      placeholder: "Enter Button 3 (MS)",
      // validation: { required: "Button 3 (MS) is required" },
    },
    {
      fieldName: "Button 3 (ZH)",
      fieldValue: "button_list[2].button_zh",
      className: "col-span-6",
      type: "text",
      name: "button_text_zh_2",
      formType: "input",
      label: "Button 3 (ZH)",
      placeholder: "Enter Button 3 (ZH)",
      // validation: { required: "Button 3 (ZH) is required" },
    },
    {
      fieldName: "Button 3 Link",
      fieldValue: "button_list[2].button_link",
      className: "col-span-6",
      type: "text",
      name: "button_link_2",
      formType: "input",
      label: "Button 3 Link",
      placeholder: "Enter Button 3 Link",
      validation: { required: "Button 3 Link is required" },
    },
  ],
  vendorLoginFooterPage: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Upload Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Copyright Text (EN)",
      fieldValue: "copyright_text_en",
      className: "col-span-6",
      type: "text",
      name: "copyright_text_en",
      formType: "input",
      label: "Copyright Text (EN)",
      placeholder: "Enter Copyright Text (EN)",
      validation: { required: "Copyright Text (EN) is required" },
    },
    {
      fieldName: "Copyright Text (MS)",
      fieldValue: "copyright_text_ms",
      className: "col-span-6",
      type: "text",
      name: "copyright_text_ms",
      formType: "input",
      label: "Copyright Text (MS)",
      placeholder: "Enter Copyright Text (MS)",
      // validation: { required: "Copyright Text (MS) is required" },
    },
    {
      fieldName: "Copyright Text (ZH)",
      fieldValue: "copyright_text_zh",
      className: "col-span-6",
      type: "text",
      name: "copyright_text_zh",
      formType: "input",
      label: "Copyright Text (ZH)",
      placeholder: "Enter Copyright Text (ZH)",
      // validation: { required: "Copyright Text (ZH) is required" },
    },
    {
      fieldName: "Button 1 (EN)",
      fieldValue: "button_list[0].button_en",
      className: "col-span-6",
      type: "text",
      name: "button_text_en_0",
      formType: "input",
      label: "Button 1 (EN)",
      placeholder: "Enter Button 1 (EN)",
      validation: { required: "Button (EN) 1 is required" },
    },
    {
      fieldName: "Button 1 (MS)",
      fieldValue: "button_list[0].button_ms",
      className: "col-span-6",
      type: "text",
      name: "button_text_ms_0",
      formType: "input",
      label: "Button 1 (MS)",
      placeholder: "Enter Button 1 (MS)",
      // validation: { required: "Button 1 (MS) is required" },
    },
    {
      fieldName: "Button 1 (ZH)",
      fieldValue: "button_list[0].button_zh",
      className: "col-span-6",
      type: "text",
      name: "button_text_zh_0",
      formType: "input",
      label: "Button 1 (ZH)",
      placeholder: "Enter Button 1 (ZH)",
      // validation: { required: "Button 1 (ZH) is required" },
    },
    {
      fieldName: "Button 1 Link",
      fieldValue: "button_list[0].button_link",
      className: "col-span-6",
      type: "text",
      name: "button_link_0",
      formType: "input",
      label: "Button 1 Link",
      placeholder: "Enter Button 1 Link",
      validation: { required: "Button 1 Link is required" },
    },
    {
      fieldName: "Button 2 (EN)",
      fieldValue: "button_list[1].button_en",
      className: "col-span-6",
      type: "text",
      name: "button_text_en_1",
      formType: "input",
      label: "Button 2 (EN)",
      placeholder: "Enter Button 2 (EN)",
      validation: { required: "Button (EN) 2 is required" },
    },
    {
      fieldName: "Button 2 (MS)",
      fieldValue: "button_list[1].button_ms",
      className: "col-span-6",
      type: "text",
      name: "button_text_ms_1",
      formType: "input",
      label: "Button 2 (MS)",
      placeholder: "Enter Button 2 (MS)",
      // validation: { required: "Button 2 (MS) is required" },
    },
    {
      fieldName: "Button 2 (ZH)",
      fieldValue: "button_list[1].button_zh",
      className: "col-span-6",
      type: "text",
      name: "button_text_zh_1",
      formType: "input",
      label: "Button 2 (ZH)",
      placeholder: "Enter Button 2 (ZH)",
      // validation: { required: "Button 12 (ZH) is required" },
    },
    {
      fieldName: "Button 2 Link",
      fieldValue: "button_list[1].button_link",
      className: "col-span-6",
      type: "text",
      name: "button_link_1",
      formType: "input",
      label: "Button 2 Link",
      placeholder: "Enter Button 2 Link",
      validation: { required: "Button 2 Link is required" },
    },

    {
      fieldName: "Button 3 (EN)",
      fieldValue: "button_list[2].button_en",
      className: "col-span-6",
      type: "text",
      name: "button_text_en_2",
      formType: "input",
      label: "Button 3 (EN)",
      placeholder: "Enter Button 3 (EN)",
      validation: { required: "Button (EN) 3 is required" },
    },
    {
      fieldName: "Button 3 (MS)",
      fieldValue: "button_list[2].button_ms",
      className: "col-span-6",
      type: "text",
      name: "button_text_ms_2",
      formType: "input",
      label: "Button 3 (MS)",
      placeholder: "Enter Button 3 (MS)",
      // validation: { required: "Button 3 (MS) is required" },
    },
    {
      fieldName: "Button 3 (ZH)",
      fieldValue: "button_list[2].button_zh",
      className: "col-span-6",
      type: "text",
      name: "button_text_zh_2",
      formType: "input",
      label: "Button 3 (ZH)",
      placeholder: "Enter Button 3 (ZH)",
      // validation: { required: "Button 3 (ZH) is required" },
    },
    {
      fieldName: "Button 3 Link",
      fieldValue: "button_list[2].button_link",
      className: "col-span-6",
      type: "text",
      name: "button_link_2",
      formType: "input",
      label: "Button 3 Link",
      placeholder: "Enter Button 3 Link",
      validation: { required: "Button 3 Link is required" },
    },

    {
      fieldName: "Button 4 (EN)",
      fieldValue: "button_list[3].button_en",
      className: "col-span-6",
      type: "text",
      name: "button_text_en_3",
      formType: "input",
      label: "Button 4 (EN)",
      placeholder: "Enter Button 4 (EN)",
      validation: { required: "Button (EN) 4 is required" },
    },
    {
      fieldName: "Button 4 (MS)",
      fieldValue: "button_list[3].button_ms",
      className: "col-span-6",
      type: "text",
      name: "button_text_ms_3",
      formType: "input",
      label: "Button 4 (MS)",
      placeholder: "Enter Button 4 (MS)",
      // validation: { required: "Button 4 (MS) is required" },
    },
    {
      fieldName: "Button 4 (ZH)",
      fieldValue: "button_list[3].button_zh",
      className: "col-span-6",
      type: "text",
      name: "button_text_zh_3",
      formType: "input",
      label: "Button 4 (ZH)",
      placeholder: "Enter Button 4 (ZH)",
      // validation: { required: "Button 4 (ZH) is required" },
    },
    {
      fieldName: "Button 4 Link",
      fieldValue: "button_list[3].button_link",
      className: "col-span-6",
      type: "text",
      name: "button_link_3",
      formType: "input",
      label: "Button 4 Link",
      placeholder: "Enter Button 4 Link",
      validation: { required: "Button 4 Link is required" },
    },
  ],
  staffLoginFooterPage: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Upload Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Copyright Text (EN)",
      fieldValue: "copyright_text_en",
      className: "col-span-6",
      type: "text",
      name: "copyright_text_en",
      formType: "input",
      label: "Copyright Text (EN)",
      placeholder: "Enter Copyright Text (EN)",
      validation: { required: "Copyright Text (EN) is required" },
    },
    {
      fieldName: "Copyright Text (MS)",
      fieldValue: "copyright_text_ms",
      className: "col-span-6",
      type: "text",
      name: "copyright_text_ms",
      formType: "input",
      label: "Copyright Text (MS)",
      placeholder: "Enter Copyright Text (MS)",
      // validation: { required: "Copyright Text (MS) is required" },
    },
    {
      fieldName: "Copyright Text (ZH)",
      fieldValue: "copyright_text_zh",
      className: "col-span-6",
      type: "text",
      name: "copyright_text_zh",
      formType: "input",
      label: "Copyright Text (ZH)",
      placeholder: "Enter Copyright Text (ZH)",
      // validation: { required: "Copyright Text (ZH) is required" },
    },
    {
      fieldName: "Button (EN)",
      fieldValue: "button_list[0].button_en",
      className: "col-span-6",
      type: "text",
      name: "button_text_en_0",
      formType: "input",
      label: "Button (EN)",
      placeholder: "Enter Button (EN)",
      validation: { required: "Button (EN) is required" },
    },
    {
      fieldName: "Button (MS)",
      fieldValue: "button_list[0].button_ms",
      className: "col-span-6",
      type: "text",
      name: "button_text_ms_0",
      formType: "input",
      label: "Button (MS)",
      placeholder: "Enter Button (MS)",
      // validation: { required: "Button (MS) is required" },
    },
    {
      fieldName: "Button (ZH)",
      fieldValue: "button_list[0].button_zh",
      className: "col-span-6",
      type: "text",
      name: "button_text_zh_0",
      formType: "input",
      label: "Button (ZH)",
      placeholder: "Enter Button (ZH)",
      // validation: { required: "Button (ZH) is required" },
    },
    {
      fieldName: "Button Link",
      fieldValue: "button_list[0].button_link",
      className: "col-span-6",
      type: "text",
      name: "button_link_0",
      formType: "input",
      label: "Button Link",
      placeholder: "Enter Button Link",
      validation: { required: "Button Link is required" },
    },
  ],
};
